import React from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';

interface Props {
    number: string;
    title: string;
    sections: Array<{ title?: string; description?: string | React.ReactNode }>;
    isDisabled?: boolean;
    isLast?: boolean;
}

const Point = (props: Props) => {
    const containerClassnames = classnames(styles.container, {
        [styles.disabled]: props.isDisabled,
        [styles.last]: props.isLast,
    });
    return (
        <div className={containerClassnames}>
            <div className={styles.point}>
                <div className={styles.number}>
                    <p className={styles.numberText}>{props.number}</p>
                </div>
                <div className={styles.verticalLine} />
            </div>
            <div className={styles.content}>
                <p className={styles.title}>{props.title}</p>
                {props.sections.map((x) => (
                    <div className={styles.section} key={x.title}>
                        {x.title && <p className={styles.title}>{x.title}</p>}
                        {x.description && <p className={styles.description}>{x.description}</p>}
                    </div>
                ))}
            </div>
        </div>
    );
};

Point.defaultProps = {
    isDisabled: false,
    isLast: false,
};

export default Point;
